export default "__VITE_ASSET__DpSe4WSt__"